import { CheckIcon } from 'lucide-react';

interface SurchargeCheckProps {
  checked: boolean;
  /** Non-optional / "included" add-ons: shown checked, not toggleable. */
  locked?: boolean;
  onToggle?: () => void;
  label: string;
}

/** A `<div>`, not a `<button>` — a button flex container mis-sizes its SVG child. */
export function SurchargeCheck({ checked, locked = false, onToggle, label }: SurchargeCheckProps) {
  const tick = checked ? <CheckIcon strokeWidth={3} aria-hidden="true" /> : null;

  if (locked) {
    return (
      <span
        className="sm-center sm-focus-ring sm-addon-check"
        data-state="locked"
        role="img"
        aria-label={`${label} (required)`}
      >
        {tick}
      </span>
    );
  }

  return (
    <div
      className="sm-center sm-focus-ring sm-addon-check"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      data-state={checked ? 'checked' : undefined}
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle?.();
        }
      }}
    >
      {tick}
    </div>
  );
}
